import { combineReducers } from "redux";

import customiseReducer from "./customise/customiseReducer";
import loginReducer from "./login/loginReducer";
import settingsReducer from "./settings/settingsReducer";
import paymentReducer from "./payment/paymentReducer";
import serviceCallReducer from "./service-call/serviceCallReducer";
import returnRequestReducer from "./return-request/returnRequestReducer";
import contractReducer from "./contract/contractReducer";
import dashboardReducer from "./dashboard/dashboardReducer";
import orderReducer from "./order/orderReducer";
import quickCreateReducer from "./quick-create/quickCreateReducer";
import supportdeskReducer from "./support-desk/supportdeskReducer";
import supportdeskSettingsReducer from "./support-desk-settings/supportdeskSettingsReducer";

const rootReducer = combineReducers({
  customise: customiseReducer,
  login: loginReducer,
  settings: settingsReducer,
  payment: paymentReducer,
  serviceCall: serviceCallReducer,
  returnRequest: returnRequestReducer,
  contract: contractReducer,
  dashboard: dashboardReducer,
  order: orderReducer,
  quickCreate: quickCreateReducer,
  supportDesk: supportdeskReducer,
  supportdeskSettings: supportdeskSettingsReducer,
});

export default rootReducer;